module.exports = __webpack_public_path__ + "img/3.c429465a.jpg";